import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../pages/Login.jsx";
import Dashboard from "../pages/Dashboard.jsx";
import AdminLayout from "../layout/AdminLayout.jsx";
import UserLayout from "../layout/UserLayout.jsx";
import ManageUsers from "../pages/Manageusers.jsx";
import ScheduleHistory from "../pages/ScheduleHistory.jsx";
import Unauthorized from "../pages/UnAuthorized.jsx";
import Setting from "../pages/Setting.jsx";
import AgentActivity from "../pages/AgentActivity.jsx";
import UsageMonitoring from "../pages/UsageMonitoring.jsx";
import Insights from "../pages/Insights.jsx";
import UserDetails from "../components/UserDetails.jsx";
import ManageAppUsers from "../pages/Manageappusers.jsx";
import AbuseReport from "../pages/AbuseReport.jsx";
import ErrorBoundary from "../components/common/ErrorBoundary.jsx";
import UserDetailsLayout from "../components/user-detail/UserDetailsLayout.jsx";
import UserSchedulesTab from "../components/user-detail/UserSchedulesTab.jsx";
import ScheduleDetail from "../components/user-detail/ScheduleDetail.jsx";
import UserDevicesTab from "../components/user-detail/UserDevicesTab.jsx";
import DeviceDetail from "../components/user-detail/DeviceDetail.jsx";
import UserRoomsTab from "../components/user-detail/UserRoomsTab.jsx";
import RoomDetail from "../components/user-detail/RoomDetail.jsx";
import UserArchiveTab from "../components/user-detail/UserArchiveTab.jsx";
import UserUpcomingTab from "../components/user-detail/UserUpcomingTab.jsx";

// ProtectedRoute component
const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, roles } = useSelector((state) => state.user);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  
  }
console.log("rolesa",roles)
  const hasAccess = roles.some((role) => allowedRoles.includes(role));
  console.log("hasAccess",hasAccess)

  console.log(hasAccess);
  if (!hasAccess) {
    return <Navigate to="/unauthorized" />;
    // return <Navigate to="/dash" />;
  }

  return <Outlet />; // render nested routes
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />

      {/* Admin Routes */}
      <Route element={<ProtectedRoute allowedRoles={["admin","user"]} />}>
        {/* Boundary here so a render crash in one page does not blank the
            whole dashboard shell — there was no error boundary at all before. */}
        <Route
          path="/admin/dash/*"
          element={
            <ErrorBoundary>
              <AdminLayout />
            </ErrorBoundary>
          }
        >
        
          <Route index path="insights"element={<Insights/>} />
          <Route  path="dashboard"element={<Dashboard />} />
          <Route path="logs-analytics" element={<ScheduleHistory />} />
          <Route path="logs-analytics/:userId" element={<ScheduleHistory />} />
          <Route path="usage-monitoring" element={<UsageMonitoring />} />
          <Route path="agent-activity" element={<AgentActivity />} />
          <Route path="manage-users" element={<ManageUsers />} />
          <Route path="manage-app-users" element={<ManageAppUsers />} />
          <Route path="settings" element={<Setting />} />

          {/* Per-user drill-down. Every one of these views is keyed on :userId,
              which is why they are tabs here rather than top-level sidebar
              pages — a global "Devices" page would have nothing to render
              until a user was chosen. */}
          <Route path="users/:userId" element={<UserDetailsLayout />}>
            <Route index element={<UserDetails />} />
            <Route path="schedules" element={<UserSchedulesTab />} />
            <Route path="schedules/:scheduleId" element={<ScheduleDetail />} />
            <Route path="devices" element={<UserDevicesTab />} />
            {/* :deviceId is Device._id, NOT the vendor deviceId. */}
            <Route path="devices/:deviceId" element={<DeviceDetail />} />
            <Route path="rooms" element={<UserRoomsTab />} />
            <Route path="rooms/:roomId" element={<RoomDetail />} />
            <Route path="upcoming" element={<UserUpcomingTab />} />
            <Route path="archive" element={<UserArchiveTab />} />
          </Route>

          <Route path="abuse-reports" element={<AbuseReport />} />
        </Route>
      </Route>

      {/* New route for user details */}
    

      {/* Unauthorized page must come BEFORE fallback */}
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};


export default AppRoutes;
